import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { ConfigurationSettingsAddNewPromptBuilder } from 'src/pages/ConfigurationPage/ConfigurationSettingsVersions/ConfigurationSettingsAddNewPopup/ConfigurationSettingsAddNewPromptBuilder/ConfigurationSettingsAddNewPromptBuilder';
import { ConfigurationSettingsAddNewPromptManually } from 'src/pages/ConfigurationPage/ConfigurationSettingsVersions/ConfigurationSettingsAddNewPopup/ConfigurationSettingsAddNewPromptManually/ConfigurationSettingsAddNewPromptManually';
import { API_VERSION } from 'src/constants/api-routes';

export const ConfigurationSettingsAddNewPopup = ({
  setPopupOpened = (() => {}) as (value: any) => void,
  onCreate = (() => {}) as (isManual?: any) => void,
  disabled = false,
  closeSettingsSelect = () => {},
}) => {
  const [open, setOpen] = useState(false);
  const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
  const isV2 = version === API_VERSION.V2;

  const close = () => {
    setOpen(false);
    setPopupOpened(false);
    closeSettingsSelect();
  };

  const onOpenChange = (open) => {
    setPopupOpened(open);
    setOpen(open);
  };

  const onTriggerClick = (e) => {
    if (isV2) {
      e.preventDefault();
      console.log(e);
      onCreate(false);
      close();
    }
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogTrigger
          disabled={disabled}
          asChild
          className={clsx(disabled && 'pointer-events-none opacity-50', 'cursor-pointer')}
          onClick={onTriggerClick}
        >
          <div className="flex flex-col py-3.5 px-4 hover:bg-[#05050d1a] cursor-pointer border-b border-b-[#e2e8f0]">
            <div className="flex gap-2 items-center justify-center">
              <p className="text-[#7A6BE5] font-bold text-sm text-center relative">
                + Add new version
              </p>
            </div>
          </div>
        </DialogTrigger>
        <DialogContent className={'z-50'} container={document.body}>
          <DialogHeader>
            <DialogTitle>Add new version</DialogTitle>
          </DialogHeader>
          <div className="grid gap-4">
            <div className="content flex flex-row items-center justify-center gap-2.5">
              <ConfigurationSettingsAddNewPromptBuilder close={close} onCreate={onCreate} />
              <ConfigurationSettingsAddNewPromptManually close={close} onCreate={onCreate} />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
